(function () {
    'use strict';

    angular.module("imApp").factory("holidayService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 569,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 570,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 571,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
